import { useLocation } from 'react-router-dom'
import {Auth, PasswordRestoreForm} from '..'

export default function PasswordRestore() {
  const {hash} = useLocation()
  const [email, token] = (hash || '').replace('#', '').split('&&')
  return (
    (!!email && !!token) ?
    <Auth title={`Please enter new password for ${email}`} backTo="/login">
      <PasswordRestoreForm token={token} email={email} />
    </Auth>
    :
    <Auth title={`Invalid parameters!`} backTo="/login">
    </Auth>
  )
}
